// Saudi dialect overrides — merged on top of base Arabic when region is "sa"
export const arSA: Record<string, any> = {
  nav: {
    contact: "تواصل معنا",
    bookSession: "احجز جلستك",
    bookSessionChange: "احجز جلستك الحين",
  },

  hero: {
    trustBadge: "حساب موثّق • +٥٠٠ تحول ناجح في السعودية",
    headlinePost: " مع نظام غذائي صحي يبدأ من تفكيرك",
    description: "استشارية تغذية علاجية — د. شيماء أنور. نصمم لك خطة تغذية متكاملة مو بس حمية. انضم لعملائنا في الرياض وجدة والدمام واحصل على نتائج تدوم.",
    spotsLeft: "٣ أماكن فاضية اليوم بس",
    ctaBook: "احجز جلسة التغيير الحين",
    ctaWhatsApp: "تواصل واتساب مباشر",
    socialProof: "+٥٠٠ عميل",
    socialProofSuffix: " في السعودية والخليج • ⭐ ٤.٩/٥",
    whatsAppMessage: "السلام عليكم د. شيماء، أبي أعرف أكثر عن برامج التغذية العلاجية",
  },

  heroTestimonials: {
    sectionLabel: "نتائج العملاء",
    heading: "نتائج حقيقية من عملاء حقيقيين",
    items: [
      { name: "نورة العتيبي", role: "ربة منزل — الرياض 🇸🇦", quote: "نزلت ١٨ كيلو في ٤ شهور وحياتي تغيرت تماماً. أحسن قرار اتخذته", stat: "-١٨ كجم", statLabel: "في ٤ شهور" },
      { name: "عبدالله الشهري", role: "رائد أعمال — جدة 🇸🇦", quote: "تركيزي وإنتاجيتي صارت أحسن بكثير. النظام سهل ويناسب حياتي", stat: "+٨٥%", statLabel: "زيادة في الطاقة" },
      { name: "ريم الدوسري", role: "أم لـ ٤ أطفال — الدمام 🇸🇦", quote: "أخيراً لقيت نظام يمشي مع العائلة كلها بدون حرمان", stat: "-١٤ كجم", statLabel: "بدون حرمان" },
    ],
  },

  therapeuticNutrition: {
    description: "التغذية العلاجية هي فرع متخصص من الطب تقدمه استشارية تغذية علاجية متخصصة، تستخدم الغذاء كأداة علاجية لتصميم خطة تغذية شخصية وجدول نظام غذائي صحي يومي متكامل لعلاج الأمراض المزمنة مثل السكري وتكيس المبايض (PCOS) وأمراض الأمعاء — بدون حمية مقيّدة أو حرمان.",
  },

  testimonials: {
    items: [
      { name: "نورة العتيبي", role: "ربة منزل — الرياض", quote: "الشغل مع الدكتورة غيّر علاقتي بالأكل تماماً. نزلت ١٨ كيلو وطاقتي صارت عالية مره. شغل العقلية كان Game changer." },
      { name: "عبدالله الشهري", role: "رائد أعمال — جدة", quote: "كشخص بيزنس مشغول، كنت أحتاج شي مستدام. برنامج النخبة ناسبني مره. إنتاجيتي وتركيزي صاروا أحسن من أي وقت." },
      { name: "ريم الدوسري", role: "أم لـ ٤ أطفال — الدمام", quote: "أخيراً لقيت نظام يمشي مع العائلة كلها. الوصفات لذيذة والدعم مذهل. هذا مو دايت — هذا نمط حياة." },
      { name: "فهد القحطاني", role: "مدير تنفيذي — الخبر", quote: "بعد سنين من الدايتات اللي ترجع، أخيراً فهمت جسمي. النظام العلمي ساعدني أرجع لياقتي وثقتي." },
    ],
  },

  foundation: {
    subtitle: "٤٠ دقيقة تكتشف فيها إذا كنت جاهز فعلاً تبدأ رحلة التغيير – فقط بـ",
    ctaTop: "ابدأ الحين",
    ctaCard: "احجز جلسة حجر الأساس",
    priceNote: "استثمار بسيط قبل أي التزام طويل المدى",
    bullets: [
      "نحدد وين أنت الحين والتحديات الحقيقية في حياتك وصحتك",
      "نرسم صورة واضحة للنسخة اللي تبي توصلها",
      "تعرف إذا كنت فعلاً مستعد لرحلة التغيير الكاملة",
    ],
    reassurance: "جلسة سريعة، استثمار بسيط، قبل ما تلتزم بأي باقة",
    detailDesc: "الجلسة هذي هي \"حجر الأساس\" اللي بنبني عليه كل اللي جاي. خلال ٤٠ دقيقة، هدفي إني أسمعك بقلب كوتش وعقل طبيبة عشان نحدد:",
    step1Desc: "بنحط يدنا على التحديات الحقيقية اللي معطلة حياتك أو مأثرة على صحتك.",
    step2Desc: "بنرسم صورة واضحة ومحددة للنسخة اللي تتمنى توصلها من نفسك فيما يتعلق بحياتك الصحية والاجتماعية.",
    quote1: "وعشان التغيير رحلة تحتاج نَفَس طويل ومجهود متبادل، فالجلسة هذي هدفها الأساسي إني أحدد العميل المستعد بجد لتحدي التغيير.",
    quote2: "مو كل الناس تكون جاهزة في الوقت الحالي لمتطلبات الرحلة هذي، وهذا حقهم تماماً..",
    quote3: "وعشان كذا، أنا أختار العميل اللي عنده عزيمة حقيقية إنه يتغير، عشان أضمن إن وقتنا ومجهودنا مع بعض يوصلون لنتيجة حقيقية واستثمار ناجح.",
  },

  services: {
    description: "كل باقة تشمل جدول نظام غذائي صحي يومي متكامل + خطة تغذية مخصصة ١٠٠% لاحتياجاتك. اختر اللي يناسب أهدافك.",
    startNow: "ابدأ الحين",
    packages: [
      {
        name: "البداية",
        duration: "٤ أسابيع",
        description: "بداية قوية لكسر العادات السيئة وبناء أساس صحي.",
        features: ["تقييم صحي شامل", "خطة وجبات مخصصة", "مكالمة كوتشينج أسبوعية ٣٠ دقيقة", "دعم عبر الإيميل", "مجموعة وصفات صحية"],
      },
      {
        name: "التحول",
        duration: "١٢ أسبوع",
        description: "برنامج شامل لتغيير نمط حياتك ونتائج تدوم.",
        features: ["تحليل أيض متعمق", "بروتوكول تغذية شخصي", "مكالمة كوتشينج أسبوعية ٦٠ دقيقة", "برنامج حركة", "جلسات كوتشينج عقلي", "دعم واتساب أولوية", "متابعة التقدم"],
      },
      {
        name: "النخبة",
        duration: "٦ شهور",
        description: "دعم VIP للمدراء التنفيذيين وأصحاب الأداء العالي اللي يبون صحة مثالية.",
        features: ["كل مميزات التحول", "جلسات ٩٠ دقيقة كل أسبوعين", "تواصل مباشر ٢٤/٧", "مراجعة تحاليل ربع سنوية", "إدارة ضغط العمل", "خطة تغذية للسفر", "إرشاد تغذية العائلة"],
      },
    ],
  },

  urgency: {
    heading: "الأماكن محدودة هالشهر",
    description: "احجز جلسة التغيير بسعر مميز الحين — ٣ أماكن فاضية بس",
    cta: "احجز جلسة التغيير الحين",
  },

  faq: {
    items: [
      { question: "وش هي التغذية العلاجية وطب نمط الحياة؟", answer: "التغذية العلاجية وطب نمط الحياة (Lifestyle Medicine) هو نهج طبي شامل يستخدم الغذاء كأداة علاجية مع التركيز على الدعائم الست للصحة: التغذية، الحركة، النوم، إدارة التوتر، العلاقات الداعمة، والتخلص من العادات الضارة. د. شيماء أنور تجمع بين التخصصين لتقديم برنامج تحول صحي متكامل — مو بس دايت." },
      { question: "وش نصيحة التغذية لحالات تكيس المبايض (PCOS)؟", answer: "لحالات تكيس المبايض، د. شيماء تصمم بروتوكول تغذية مضاد للالتهابات يركز على: تقليل مقاومة الأنسولين بأطعمة منخفضة المؤشر الجلايسيمي، زيادة الأوميجا ٣، تحسين مستويات فيتامين D، إدارة هرمونات التوتر، والتخلص من الأطعمة المصنعة والسكريات. كل خطة مخصصة حسب التحاليل الهرمونية والأعراض الفردية." },
      { question: "كيف أحصل على خطة تغذية شخصية لمريض سكري في السعودية؟", answer: "د. شيماء أنور تقدم خطط تغذية شخصية ١٠٠% لمرضى السكري في كل مدن السعودية أونلاين. الخطة تشمل: جدول وجبات صديق لسكر الدم، حساب وتوزيع الكربوهيدرات، بدائل من الأكل السعودي المحلي، تنسيق بين الأدوية والتغذية، ومتابعة أسبوعية لمستويات الجلوكوز." },
      { question: "كيف أوقف الأكل العاطفي وأنزل وزني؟", answer: "الأكل العاطفي هو طريقة تعامل مع التوتر والقلق والملل. نهج د. شيماء يعالج الأكل العاطفي من خلال: ١) تحديد المحفزات (توتر، وحدة، ملل)، ٢) كوتشينج نفسي لكسر دورة الأكل-الذنب، ٣) بناء بدائل صحية للتعامل مع المشاعر، ٤) تعديلات غذائية تثبّت سكر الدم وتقلل الرغبة الشديدة في الأكل." },
      { question: "طاقتي تنزل بعد الغدا — وش آكل؟", answer: "انخفاض الطاقة بعد الغدا سببه عادة ارتفاع سكر الدم ثم انخفاضه السريع. الحل: وجبات متوازنة (بروتين + دهون صحية + كربوهيدرات معقدة)، توقيت الوجبات الصحيح، التخلص من السكريات المخفية والكربوهيدرات المكررة، إضافة سناكس مثبتة للطاقة، وتحسين الترطيب." },
      { question: "النوم والتوتر يأثرون على وزني — وش أسوي؟", answer: "العلاقة بين النوم والتوتر والوزن حقيقية وموثقة علمياً. النوم السيء يزيد هرمون الجوع (جريلين) ويقلل هرمون الشبع (لبتين)، والتوتر المزمن يرفع الكورتيزول ويخزن دهون البطن. د. شيماء تعالج هذا من خلال: بروتوكولات نوم صحي، تقنيات إدارة التوتر، تعديلات غذائية تدعم النوم." },
      { question: "أبي أنزل وزني بدون دايت مقيّد أو حرمان", answer: "فلسفة د. شيماء كلها مبنية على إنقاص الوزن المستدام بدون حرمان: ما في عد سعرات، ما في حذف مجموعات غذائية، ما في تجويع. بدال كذا، نركز على: فهم إشارات جسمك، بناء علاقة صحية مع الأكل، وجبات ممتعة من أكلك المحلي، معالجة الحواجز النفسية لخسارة الوزن، وتغييرات تدريجية في نمط الحياة تدوم للأبد." },
      { question: "المتابعة كيف تكون؟", answer: "مكالمات كوتشينج أسبوعية (٣٠-٩٠ دقيقة حسب الباقة) + دعم واتساب يومي + متابعة تقدمك المستمر مع تعديل الخطة حسب نتائجك. البرنامج أونلاين بالكامل ويناسب عملاء السعودية والخليج." },
      { question: "وش أسعار الباقات بالريال السعودي؟", answer: "باقة البداية ≈٢٦٠ ريال سعودي. باقة التحول ≈٦٧٠ ريال. باقة النخبة ≈١,٨٦٠ ريال. الأسعار تقريبية حسب سعر الصرف." },
    ],
  },

  leadMagnet: {
    description: "ابدأ تحولك مع نظامي المُثبت. بتوصلك نصائح يومية عملية للتغذية والحركة والعقلية على إيميلك.",
    socialLine: "انضم لأكثر من ٥,٠٠٠ شخص في رحلة الحيوية. تقدر تلغي الاشتراك في أي وقت.",
  },

  contact: {
    tag: "تواصل معنا",
    heading: "مستعد تبدأ تحولك؟",
    description: "سواء عندك أسئلة عن البرامج أو مستعد تاخذ أول خطوة، يسعدني أسمع منك. خلنا نشوف كيف نقدر نشتغل مع بعض.",
    locationValue: "القاهرة، مصر (متاح أونلاين للسعودية والخليج)",
    messagePlaceholder: "قولي عن أهدافك وكيف أقدر أساعدك...",
    submit: "أرسل الرسالة",
  },

  socialProof: {
    suffix: "+٥٠٠ تحول ناجح في السعودية والخليج",
    items: [
      { name: "نورة ع.", location: "الرياض 🇸🇦", text: "نزلت ١٨ كيلو في ٤ شهور" },
      { name: "فهد ق.", location: "جدة 🇸🇦", text: "تغيرت حياتي بالكامل" },
      { name: "ريم د.", location: "الدمام 🇸🇦", text: "أفضل قرار اتخذته لصحتي" },
      { name: "عبدالله ش.", location: "الخبر 🇸🇦", text: "نتائج رائعة من أول شهر" },
      { name: "سارة م.", location: "المدينة 🇸🇦", text: "طاقتي ومزاجي تحسنوا مره" },
    ],
  },

  stickyCta: {
    text: "احجز جلسة التغيير الحين",
  },

  booking: {
    whatsAppConfirmMsg: "السلام عليكم، حجزت جلسة وأبي أأكد الموعد",
    whatsAppConfirmFoundation: "السلام عليكم، حجزت جلسة حجر الأساس وأبي أأكد الموعد",
  },

  whatsapp: {
    message: "السلام عليكم د. شيماء، أبي أعرف أكثر عن برامج التغذية العلاجية",
  },
};
